import { GroupsEnum } from 'types/users';
import { formatServiceTypeTitle } from 'utils/helpers';

/**
 * Определяет ID магазина в зависимости от прав пользователя
 * @param user - объект пользователя с группами
 * @param store - объект магазина
 * @returns ID магазина (пустая строка для всех магазинов, ID для конкретного, null если нет доступа)
 */
export const determineStoreAccess = (user: any, store: any): string | null => {
	if (!user) return null;

	// Администраторы имеют доступ ко всем магазинам
	if (user.groups && user.groups.indexOf(GroupsEnum.ADMIN) > -1) {
		return '';
	}

	// Пользователи с полным доступом к данным имеют доступ ко всем магазинам
	if (user.groups && user.groups.indexOf(GroupsEnum.FULL_ACCESS) > -1) {
		return '';
	}

	// РД доступы имеют доступ к своим магазинам (фильтр по РД происходит на бэкенде)
	if (user?.groups?.some((group: string) => group.startsWith('/rdaccess/rdaccess.'))) {
		return '';
	}

	// Остальные пользователи имеют доступ только к своему магазину
	if (store?.id) {
		return store.id;
	}

	return null;
};

/**
 * Сортирует данные по номеру магазина
 */
export const sortDataByStoreNumber = (data: any[]): any[] => {
	return [...data].sort((a: any, b: any) => {
		const numberA = a.checkin?.store?.number || 0;
		const numberB = b.checkin?.store?.number || 0;
		return numberA - numberB;
	});
};

/**
 * Форматирует позицию пользователя (основная или аутсорс)
 */
export const formatUserPosition = (user: any): string => {
	return formatServiceTypeTitle(user?.position ?? user?.outsourcing?.pos?.title ?? '');
};
